import { State } from '../../reducers/rootReducer'
import { VwnRecommendationsForModelDataState } from '../../reducers/vwnRecommendationsForModelDataReducer'

const vwnRecommendationsForModelDataSelector = (state: State): VwnRecommendationsForModelDataState => state.vwnRecommendationsForModel

export default vwnRecommendationsForModelDataSelector
